<template>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%">
        <div class="info-item">
            <!-- <input type="button" class="btn btn-blue" value="上传头像" @click="finish('blob')" /> -->
            <div class="line">
                <div class="cropper-content">
                    <div class="cropper">
                        <vueCropper
                            ref="cropper"
                            :img="option.img"
                            :outputSize="option.size"
                            :outputType="option.outputType"
                            :info="true"
                            :full="option.full"
                            :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox"
                            :original="option.original"
                            :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            :fixedBox="option.fixedBox"
                            @realTime="realTime"
                            @imgLoad="imgLoad"
                        ></vueCropper>
                    </div>
                    <div style="margin-left:20px;">
                        <div
                            class="show-preview"
                            :style="{ width: '300px', height: '300px', overflow: 'hidden', margin: '5px' }"
                        >
                            <div :style="previews.div" class="preview">
                                <img :src="previews.url" :style="previews.img" style="width: 100%;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { VueCropper } from "vue-cropper";

export default {
    name: "cropper-canvas",
    components: {
        VueCropper,
    },
    props: {},
    data() {
        return {
            dialogVisible: false,
            headImg: "",
            //剪切图片上传
            crap: false,
            previews: {},
            option: {},
            fileName: "", //本机文件地址
            downImg: "#",
            imgFile: "",
            uploadImgRelaPath: "", //上传后的图片的地址（不带服务器域名）
        };
    },
    mounted() {},
    methods: {
        init(data) {
            this.dialogVisible = true;
            this.option = data;
        },
        //上传图片（点击上传按钮）
        finish(type) {
            console.log("finish");
            // let _this = this;
            let formData = new FormData();
            // 输出
            if (type === "blob") {
                this.$refs.cropper.getCropBlob(data => {
                    let img = window.URL.createObjectURL(data);
                    this.model = true;
                    this.modelSrc = img;
                    formData.append("file", data, this.fileName);
                    // this.$http.post(Api.uploadSysHeadImg.url, formData, {contentType: false, processData: false, headers:{'Content-Type': 'application/x-www-form-urlencoded'}})
                    // .then((response)=>{
                    //   var res = response.data;
                    //   if(res.success == 1){
                    //     $('#btn1').val('');
                    //     _this.imgFile = '';
                    //     _this.headImg = res.realPathList[0];  //完整路径
                    //     _this.uploadImgRelaPath = res.relaPathList[0];  //非完整路径
                    //     _this.$message({
                    //       type: 'success',
                    //       message: '上传成功'
                    //     });
                    //   }
                    // })
                });
            } else {
                this.$refs.cropper.getCropData(data => {
                    this.model = true;
                    this.modelSrc = data;
                });
            }
        },
        // 实时预览函数
        realTime(data) {
            this.previews = data;
            console.log(data);
        },
        imgLoad(msg) {
            console.log("imgLoad");
            console.log(msg);
        },
        confirm() {
            console.log(this.previews, 44444);
            this.$emit("addList", this.previews);
            this.dialogVisible = false;
        },
    },
};
</script>
<style lang="scss">
.info {
    width: 720px;
    margin: 0 auto;
    .oper-dv {
        height: 20px;
        text-align: right;
        margin-right: 100px;
        a {
            font-weight: 500;
            &:last-child {
                margin-left: 30px;
            }
        }
    }
}
.info-item {
    margin-top: 15px;
    label {
        display: inline-block;
        width: 100px;
        text-align: right;
    }
    .sel-img-dv {
        position: relative;
        .sel-file {
            position: absolute;
            width: 90px;
            height: 30px;
            opacity: 0;
            cursor: pointer;
            z-index: 2;
        }
        .sel-btn {
            position: absolute;
            cursor: pointer;
            z-index: 1;
        }
    }
}
.cropper-content {
    display: flex;
    // display: -webkit-flex;
    // justify-content: flex-end;
    // -webkit-justify-content: flex-end;
    .cropper {
        width: 500px;
        height: 500px;
    }
    .show-preview {
        flex: 1;
        -webkit-flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
        .preview {
            overflow: hidden;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
        }
    }
}
.cropper-content .show-preview .preview {
    margin-left: 0;
}
</style>
